<div style="position: relative;">
    <div [class]="'d-flex justify-content-start align-items-center circle ' + iconBg" [class.big]="big">
        <mat-icon [style]="'position: relative; right: -6px; transform: scale(' + scale + ');' " [class]="currentIconClass">
            <!-- <mat-icon style="position: relative; right: -2px; transform: scale(0.75);  " [class]="currentIconClass"> -->
            <ng-content></ng-content>
        </mat-icon>

    </div>

    <div *ngIf="stateColor" [class]="'state ' + stateColor">

    </div>

    <div *ngIf="stateColor == 'state-0' || stateColor == 'state-entity-2'" style="bottom: -5px;
        position: absolute; right: 0px;">
        <svg width="8" height="8" viewBox="0 0 8 8" class=" R90p3b vMbxHf H14eUd ">
            <g fill-rule="evenodd">
                <path fill-rule="nonzero"
                    d="M4 6.75a2.75 2.75 0 1 0 0-5.5 2.75 2.75 0 0 0 0 5.5zM4 8a4 4 0 1 1 0-8 4 4 0 0 1 0 8z"></path>
            </g>
        </svg>
    </div>

</div>